import { columnize } from './projectionLayout';
import { optionLabelStyle } from './projectionScale';

// WIP-011 (design §1, §2.2, C2) — the OPEN state's option list: labels only,
// never a count or a bar. Live bars while voting is open cause herding
// (students vote for the tallest bar) — the design's whole answer to that is
// "nothing about the options changes until Show results", so this component
// literally cannot render a count; it isn't given one.
export default function ProjectionOptionsList({ options }: { options: string[] }) {
  const columns = columnize(options);
  const labelStyle = optionLabelStyle(options.length);
  return (
    <div className={columns.length > 1 ? 'grid w-full grid-cols-2 gap-x-10 gap-y-3' : 'flex w-full flex-col gap-3'}>
      {columns.map((column, ci) => (
        <div key={ci} className="flex flex-col gap-3">
          {column.map((label, i) => (
            <div key={i} style={labelStyle} className="text-ws-ink">{label}</div>
          ))}
        </div>
      ))}
    </div>
  );
}
